module.exports = __webpack_public_path__ + "img/tua_tagovailoa.54ab4b0b.png";